import { render, staticRenderFns, recyclableRender, components } from "./policyDetails.vue?vue&type=template&id=5c7d1328&scoped=true&"
var renderjs
import script from "./policyDetails.vue?vue&type=script&lang=js&"
export * from "./policyDetails.vue?vue&type=script&lang=js&"
import style0 from "./policyDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./policyDetails.vue?vue&type=style&index=1&id=5c7d1328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d1328",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/policyDetails/policyDetails.vue"
export default component.exports